import type { MultiSelectOption } from "@/components/ui/multi-select"

/**
 * Predefined target market options for organization configuration.
 * Used in onboarding and settings pages.
 */
export const TARGET_MARKET_OPTIONS: MultiSelectOption[] = [
  { value: "b2b", label: "B2B" },
  { value: "b2c", label: "B2C" },
  { value: "enterprise", label: "Enterprise" },
  { value: "smb", label: "SMB" },
  { value: "mid_market", label: "Mid-Market" },
  { value: "government", label: "Government" },
  { value: "education", label: "Education" },
  { value: "healthcare", label: "Healthcare" },
  { value: "nonprofit", label: "Non-Profit" },
  { value: "startup", label: "Startups" },
]

/**
 * Lookup record from value to label for displaying target markets.
 */
export const TARGET_MARKET_LABELS: Record<string, string> = Object.fromEntries(
  TARGET_MARKET_OPTIONS.map((opt) => [opt.value, opt.label])
)
